import { render } from "./PersonasView.vue?vue&type=template&id=335bbb5d"
import script from "./PersonasView.vue?vue&type=script&lang=js"
export * from "./PersonasView.vue?vue&type=script&lang=js"

import exportComponent from "/home/xavi/Escriptori/rocabo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__